package com.essntl.features.service.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.service.domain.use_case")
class ExtraCategoryServiceUseCaseModule